import { cleanState, useComite } from '../../../../../appStore/comite';
import { useDispatch } from 'react-redux';
import { useConcurso } from '../../../../../providers/ConcursoProvider';
import { PresentesForm } from './PresentesForm';
import { useEffect, useState } from 'react';
import { CardModal } from '../../../../CompUtils/CardModal';
import { postGenerarAprobacion } from '../../../../../appStore/actas';
import { UsuarioProps } from '../../../../Usuario/UpdateUser';
import Form from '../../../../CompUtils/Form';

export interface MiembroComiteType extends UsuarioProps {
  idUsuarioComite: number;
  representacion: string;
  titular: boolean;
  comite_rol: number;
  comite_rol_nombre: string;
  presente?: boolean;
}

/* const { Form } = createFormCtx<Record<string, boolean>>(); */

type Props = { onClose: () => void; open: boolean };
export const ComiteMiembrosPopup = (props: Props) => {
  const { onClose, open } = props;
  const [values, setValues] = useState();
  const dispatch = useDispatch();
  const { idLlamadoConcurso } = useConcurso();
  const { miembros } = useComite();

  useEffect(() => {
    const keys = miembros?.map((miembro) => {
      return miembro.idUsuarioComite;
    });
    const presentes = keys?.reduce(
      (a, key) => Object.assign(a, { [key]: { presente: false } }),
      {},
    );
  }, [miembros]);

  useEffect(() => {
    return () => {
      dispatch(cleanState());
    };
  }, [dispatch]);
  if (!miembros) return null;

  return (
    <CardModal open={open} onClose={onClose} title="Indicar presencia para firma de acta">
      <Form
        submitText="Confirmar"
        size="full"
        onSubmit={(valores: any) => {
          dispatch(postGenerarAprobacion({ idLlamadoConcurso, valores }));
        }}
        btns={['submit']}>
        <PresentesForm presentes={miembros} values={values} setValues={setValues} />
      </Form>
    </CardModal>
  );
};
